// extracted by mini-css-extract-plugin
export default {"root":"mobile_menu_root__MhrmY","dark":"mobile_menu_dark__BmVR3","toggle":"mobile_menu_toggle__s7lyK","menu":"mobile_menu_menu__9yb45"};